import { render, staticRenderFns } from "./forgetpasswd.vue?vue&type=template&id=034a9e20&scoped=true&"
import script from "./forgetpasswd.vue?vue&type=script&lang=js&"
export * from "./forgetpasswd.vue?vue&type=script&lang=js&"
import style0 from "./forgetpasswd.vue?vue&type=style&index=0&id=034a9e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a9e20",
  null
  
)

export default component.exports